import {useNavigate} from 'react-router-dom'

import Style from './style'

import MainHeader from 'widget/MainHeader'
import Search from 'widget/Search'
import Pagenation from 'widget/Pagenation'

import useGetEventList from 'entity/event/useGetEventList'

import TStyle from 'shared/style/tableStyle'
import timestampCalculator from 'shared/lib/timestampCalculator'
import {convertEventStateAsName} from 'shared/constant/lookup/eventState'
import {convertEventTypeAsName} from 'shared/constant/lookup/eventType'
import {convertProGradeAsName} from 'shared/constant/lookup/proGrade'
import TableLoading from 'shared/ui/TableLoading'
import useRoleCookie from 'shared/model/useRoleCookie'
import {
	ROLE_TIMER_MANAGER,
	ROLE_FIELD_MANAGER,
	ROLE_COMPETITION_MANAGER,
} from 'shared/constant/lookup/role'

const EventList = () => {
	const navigate = useNavigate()
	const [userRole] = useRoleCookie()

	const [eventList, isLoading] = useGetEventList()

	const isManager =
		userRole === ROLE_TIMER_MANAGER ||
		userRole === ROLE_FIELD_MANAGER ||
		userRole === ROLE_COMPETITION_MANAGER

	const btnList = [
		{
			label: '생성',
			clickEvent: () => navigate('/event/create'),
			deactive: false,
		},
	]

	const sizeList = [
		'long',
		'short',
		'expand',
		'medium',
		'medium',
		'medium',
		'long',
	]
	const tableHeadList = [
		'대회 날짜',
		'IDX',
		'대회 이름',
		'대회 종류',
		'요구 프로 자격',
		'상태',
		'생성 날짜',
	]

	return (
		<Style.Wrapper>
			<MainHeader btnList={!isManager ? [] : btnList} mobileLayout='none'>
				대회 목록
			</MainHeader>
			<Search placeholder='콘테스트 이름으로 검색 가능' />

			<TableLoading isLoading={isLoading}>
				<TStyle.TableDiv>
					<TStyle.TableInner>
						<TStyle.TableRow $title>
							{tableHeadList.map((elem, index) => (
								<TStyle.Data key={index} $title $size={sizeList[index]}>
									{elem}
								</TStyle.Data>
							))}
						</TStyle.TableRow>
						{eventList?.data?.event_list?.map((elem, index) => (
							<TStyle.TableRow
								key={index}
								$odd={index % 2 === 1}
								onClick={() => navigate(`/event/${elem?.idx}/detail`)}
							>
								<TStyle.Data $size={sizeList[0]}>
									{timestampCalculator(elem?.date)}
								</TStyle.Data>
								<TStyle.Data $size={sizeList[1]}>{elem?.idx}</TStyle.Data>
								<TStyle.Data $size={sizeList[2]}>{elem?.name}</TStyle.Data>
								<TStyle.Data $size={sizeList[3]}>
									{convertEventTypeAsName[elem?.event_type_flag]}
								</TStyle.Data>
								<TStyle.Data $size={sizeList[4]}>
									{convertProGradeAsName[elem?.pro_grade_flag]}
								</TStyle.Data>
								<TStyle.Data $size={sizeList[5]}>
									{convertEventStateAsName[elem?.event_state_flag]}
								</TStyle.Data>
								<TStyle.Data $size={sizeList[6]}>
									{timestampCalculator(elem?.created_at)}
								</TStyle.Data>
							</TStyle.TableRow>
						))}
					</TStyle.TableInner>
				</TStyle.TableDiv>
			</TableLoading>

			<Pagenation maxPage={eventList?.data?.max_page} />
		</Style.Wrapper>
	)
}

export default EventList
